var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 1.65039L15.8036 7.21509L22.2719 9.11319L18.1544 14.4502L18.3479 21.1876L12.0002 18.9214L5.65252 21.1876L5.84602 14.4502L1.72852 9.11319L8.19682 7.21509L12.0002 1.65039ZM12.0002 4.83999L9.32002 8.76219L4.76152 10.0987L7.66402 13.8589L7.52632 18.6064L12.0002 17.0098L16.4732 18.6064L16.3364 13.8589L19.238 10.0987L14.6804 8.76219L12.0002 4.83999ZM10.2002 12.0004C10.2002 12.4778 10.3899 12.9356 10.7274 13.2732C11.065 13.6107 11.5228 13.8004 12.0002 13.8004C12.4776 13.8004 12.9354 13.6107 13.273 13.2732C13.6106 12.9356 13.8002 12.4778 13.8002 12.0004H15.6002C15.6002 12.9552 15.2209 13.8708 14.5458 14.546C13.8707 15.2211 12.955 15.6004 12.0002 15.6004C11.0454 15.6004 10.1298 15.2211 9.45463 14.546C8.7795 13.8708 8.40022 12.9552 8.40022 12.0004H10.2002Z",
    fill: "#525866"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSmile);
export default __webpack_public_path__ + "static/media/star-smile.e231f5f4faf16df61a129c53e1980ce6.svg";
export { ForwardRef as ReactComponent };